// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import Vue from 'vue';
import { wrapResponseWithDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import RequestConfig from '@glittr/frontend-core/src/plugins/servicelayer/requestConfig';
import GetDynamicFormDefinitionRequestModel from '../../model/get-dynamic-form-definition-request-model';
import PostDynamicFormRequestModel from '../../model/post-dynamic-form-request-model';
import DynamicFormUploadDocumentRequestModel from '../../model/dynamic-form-upload-document-request-model';
import DynamicFormDefinitionModel from '../../model/dynamic-form-definition-model';

export default (service: Servicelayer) => ({
  /**  */
  async getDynamicFormDefinition(request: GetDynamicFormDefinitionRequestModel, config?: RequestConfig) {
    const requestDTO = GetDynamicFormDefinitionRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-dynamic-form-definition'] ?? 'core/DynamicForm/Definition';
    const response = await service.get<any>(endpointPath, {
      query: {
        appSystemKey: requestDTO.appSystemKey,
        id: requestDTO.id,
        businessUnit: requestDTO.businessUnit,
      },
      ...config,
    });
    const dto = response.data.result;
    return wrapResponseWithDataRecord(DynamicFormDefinitionModel.toModel(dto));
  },
  /**  */
  async postDynamicForm(request: PostDynamicFormRequestModel, config?: RequestConfig) {
    const requestDTO = PostDynamicFormRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-post-dynamic-form'] ?? 'core/DynamicForm';
    const response = await service.post<any>(endpointPath, {
      body: {
        appSystemKey: requestDTO.appSystemKey,
        form: requestDTO.form,
      },
      ...config,
    });
    const result = response?.data?.result ?? response?.data;
    return wrapResponseWithDataRecord(result as string | undefined);
  },
  /**  */
  async dynamicFormUploadDocument(request: DynamicFormUploadDocumentRequestModel, config?: RequestConfig) {
    const requestDTO = DynamicFormUploadDocumentRequestModel.toDTO(request);
    const formData = new FormData();
    formData.append('uploadFile', requestDTO.uploadFile as Blob);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-dynamic-form-upload-document'] ?? 'core/DynamicForm/Documents/Upload';
    const response = await service.post<any>(endpointPath, {
      body: formData,
      headers: {
      },
      ...config,
    });
    const result = response?.data?.result ?? response?.data;
    return wrapResponseWithDataRecord(result as string | undefined);
  },
});
